import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NbJSThemeOptions, NbThemeService } from '@nebular/theme';
import { technologyTypes } from '@shared/constants/technology-types';
import { IDashboardStatistics } from '@shared/interfaces/statistics/dashboard-statistics.interface';
import { IPrintingTime } from '@shared/interfaces/statistics/printing-time';
import { IUsedMaterials } from '@shared/interfaces/statistics/used-materials';
import { ApiService } from '@shared/services/api.service';
import { Observable, share, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatsCardComponent implements OnInit {  
  private nbTheme: NbJSThemeOptions;
  private subscriptions = new Subscription();

  protected printTimeColors: string[];
  protected materialColors: string[];

  protected isLoading = false;
  protected data$: Observable<IDashboardStatistics>;

  @Input() 
  public set isFGF(value: boolean) {
    this.data$ = this.apiService.getDashboardStatistics(value ? technologyTypes.FGF : technologyTypes.FFF)
      .pipe(
        share(),
        tap(() => this.isLoading = false)
      );
  }

  protected get fromUnit(): string {
    return 'g';
  } 
  
  protected get toUnit(): string {
    return 'kg';
  } 

  constructor(
    private readonly nbThemeService: NbThemeService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.nbThemeService.getJsTheme()
        .subscribe(theme => {
          this.nbTheme = theme;

          this.printTimeColors = this.nbTheme.variables!['chartTimeUsedColors'] as string[];
          this.materialColors = this.nbTheme.variables!['chartMaterialColors'] as string[];

          this.printTimeColors.reverse();
          this.changeDetector.markForCheck();
        })
    );
  }

  protected totalPrintingTime(printingTime: IPrintingTime): number { 
    return printingTime.finishedPrintsTime + printingTime.interruptedPrintsTime;
  }

  protected getPrintTimeChart(printingTime: IPrintingTime): Array<{ name: string, value: number }> {
    return [
      { name: '', value: printingTime.finishedPrintsTime },
      { name: '', value: printingTime.interruptedPrintsTime }
    ];
  }

  protected getMaterialUsage(materialUsage: IUsedMaterials): Array<{ name: string, value: number }> {
    return materialUsage.usedMaterials
      .map(material => ({ name: material.materialName, value: material.totalMaterialUsage }));
  }
}
